import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Screen } from '~/components/screens/home'

const Page = () => (
  <>
    <Seo />
    <Screen />
  </>
)

export default Page
